import { Declaration } from 'store/declarations/declaration';
import DeclarationStatusTag from 'components/ui/composed/declarations/declaration-status/DeclarationStatusTag';
import EmptyCell from 'components/new-ui/base/emtpy-cell/EmptyCell';
import { getDeclarationDisplayStatus } from './getDeclarationDisplayStatus';

type Props = {
    declaration?: Declaration;
    dataTestId?: string;
};

const Status = ({ dataTestId, declaration }: Props) => {
    if (!declaration) {
        return <EmptyCell dataTestId={dataTestId} />;
    }

    const status = getDeclarationDisplayStatus(declaration);
    if (status) {
        return <DeclarationStatusTag status={status} dataTestId={dataTestId} />;
    }

    return <EmptyCell dataTestId={dataTestId} />;
};

export default Status;
